export default __webpack_public_path__ + "static/media/man_in_the_wind_11.d75b4fb5.png";